import { render, staticRenderFns } from "./partyBrand.vue?vue&type=template&id=01125c3c&scoped=true"
import script from "./partyBrand.vue?vue&type=script&lang=js"
export * from "./partyBrand.vue?vue&type=script&lang=js"
import style0 from "./partyBrand.vue?vue&type=style&index=0&id=01125c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01125c3c",
  null
  
)

export default component.exports